// GENERATED FILE - do not edit directly.
// Regenerated by :webHtmlApp:generateStrings from
// shared/src/commonMain/moko-resources/base/strings.xml - edit that file instead.
package xyz.tyiu.satsprice

object Strings {
    const val addCurrency: String = "Add currency"
    const val bitcoinSectionTitle: String = "Bitcoin"
    const val btcLabel: String = "BTC"
    fun btcToCurrency(arg1: String): String = "BTC to ${arg1}"
    const val cancel: String = "Cancel"
    const val clearSearchContentDescription: String = "Clear search"
    const val currenciesSectionTitle: String = "Currencies"
    fun currenciesSelectedCount(arg1: Int): String = "${arg1} selected"
    const val currentCurrencySectionTitle: String = "Current Currency"
    fun currencyNotPriced(arg1: String): String = "Not priced by ${arg1}"
    fun currencyOptionLabel(arg1: String, arg2: String): String = "${arg1} - ${arg2}"
    fun currencyOptionsContentDescription(arg1: String): String = "Options for ${arg1}"
    fun currencyToSats(arg1: String): String = "${arg1} to Sats"
    const val done: String = "Done"
    fun exceedsMaxSupply(arg1: String): String = "Exceeds the ${arg1} maximum supply"
    const val loadingRatesStatus: String = "Loading rates…"
    const val moveCurrencyDownContentDescription: String = "Move down"
    const val moveCurrencyToBottomContentDescription: String = "Move to bottom"
    const val moveCurrencyToTopContentDescription: String = "Move to top"
    const val moveCurrencyUpContentDescription: String = "Move up"
    const val priceSource: String = "Price Source"
    const val pricedCurrenciesSectionTitle: String = "Priced Currencies"
    const val refreshContentDescription: String = "Refresh"
    const val removeCurrencyContentDescription: String = "Remove"
    const val resetSelectedCurrenciesButton: String = "Reset"
    fun resetSelectedCurrenciesConfirmationMessage(arg1: String): String = "This keeps ${arg1}, but removes every other currency you've added."
    const val resetSelectedCurrenciesConfirmationTitle: String = "Remove all selected currencies?"
    const val retry: String = "Retry"
    const val satsLabel: String = "Sats"
    const val searchCurrenciesPlaceholder: String = "Search currencies"
    const val selectedCurrenciesSectionTitle: String = "Selected Currencies"
    const val unpricedCurrenciesSectionTitle: String = "Unpriced Currencies"
    fun updatedStatus(arg1: String): String = "Updated ${arg1}"
}
